import React from 'react';

const useReturnFocus = (
  $isOpen: boolean,
  focusRef: React.RefObject<HTMLElement> | undefined
) => {
  const modalRef = React.useRef<Element | null>(null);
  React.useEffect(() => {
    if (!$isOpen && modalRef.current && focusRef && focusRef.current) {
      focusRef.current.focus();
      modalRef.current = null;
    } else if ($isOpen) {
      modalRef.current = document.activeElement;
    }
  }, [$isOpen, focusRef]);
};

export default useReturnFocus;
